import { showAPIErrorMessage } from "utilities/apiHandler";
import { bulkActionToast } from "utilities/toast/bulkActionToast";

import { billsMassUpdateApprovalStatusPutV2 } from "handlers/bills/bills";
import { ApprovalStatus } from "handlers/models";

import {
    getSelectionDocType,
    type IBillRowSelection,
} from "entity/bill/BillList/utils/billFloatingBarActionEligibility";
import { getBillBulkSummary } from "entity/bill/common/getBillToastMessage";

// Shared bulk-approve flow used by both the bill approval queue page and the bill list FAB.
// Centralizes the call into the mass-update-approval endpoint and the three-way result toast so
// the two consumers stay in lockstep. Post-approve cleanup (deselect, reload) is caller-managed.
//
// Takes the selected rows and derives the toast's document type here, next to the toast itself, so
// callers don't compute and pass it separately.
export async function performBulkApprove(selectedBills: IBillRowSelection[]) {
    try {
        const response = await billsMassUpdateApprovalStatusPutV2({
            billIds: selectedBills.map((bill) => bill.id),
            targetStatus: ApprovalStatus.Approved,
        });

        const updatedCount = response.data.updatedCount ?? 0;
        const totalCount = response.data.totalCount ?? 0;
        const mainDocType = getSelectionDocType(selectedBills);
        bulkActionToast(updatedCount, totalCount, getBillBulkSummary("approved", mainDocType));
    } catch (error) {
        showAPIErrorMessage(error);
    }
}
